module.exports = __webpack_public_path__ + "static/media/ios_tips_02.c0a587a8.png";